"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppFooter = void 0;
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = tslib_1.__importStar(require("styled-components"));
const ui_common_components_1 = require("@desygner/ui-common-components");
const { rem } = ui_common_components_1.utils;
const StyledWrapper = styled_components_1.default.div `
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  position: ${({ isEmbedded }) => (isEmbedded ? 'static' : 'absolute')};
  /* padding: ${({ theme, isEmbedded }) => isEmbedded ? 0 : rem(theme.Components.ToolBar.padding)}; */
  padding-top: ${({ theme }) => rem(theme.Components.ToolBar.padding)};
  justify-content: flex-end;
  left: 0;
  bottom: 0;
  width: 100%;

  ${({ theme, isEmbedded }) => (0, styled_components_1.css) `
    background-color: ${theme.Components.Panel.Background};
    border-top: ${isEmbedded ? 0 : rem(theme.Border.Size.Small)} solid
      ${theme.Color.Neutrals.Border};
    gap: ${ui_common_components_1.utils.rem(theme.Spacing.Size.XSmall)};
  `}
`;
function AppFooter({ children, isEmbedded }) {
    return ((0, jsx_runtime_1.jsx)(StyledWrapper, { isEmbedded: isEmbedded !== null && isEmbedded !== void 0 ? isEmbedded : false, children: children }));
}
exports.AppFooter = AppFooter;
//# sourceMappingURL=AppFooter.js.map